import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import SuggestionFilter from '../../../FiltersField/formatters/SuggestionFilter';
import camelize from '@afosto/utils/string/camelize';
import capitalize from '@afosto/utils/string/capitalize';

const CategoryFilter = props => {
  const intl = useIntl();

  return (
    <SuggestionFilter
      {...props}
      getOptionSelected={(option, value) => value === option.value}
      getOptionLabel={option => {
        if (typeof option === 'object') {
          return option.label;
        }

        return intl.formatMessage({
          id: `auditCategories.${camelize(option?.toLowerCase())}`,
          defaultMessage: capitalize(option ?? ''),
          description: `audit category ${option}`,
        });
      }}
    />
  );
};

export default CategoryFilter;
